import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useForm from '@components/form/hooks/useForm';

import { updateSuperAdminUserPassword } from '@actions/superAdminUsers';
import {
    getSuperAdminUserIsPosting,
    getSuperAdminUserPostSuccess,
} from '@selectors/superAdminUsers';

export default function useUpdateSuperAdminPassword(
    userID: number,
): UpdateSuperAdminPasswordReturn {
    const dispatch = useDispatch();

    const [formState, handleChange] = useForm({ password: '', confirmPassword: '' });

    const handleSubmit = useCallback(() => {
        dispatch(updateSuperAdminUserPassword(userID, formState));
    }, [dispatch, userID, formState]);

    const isPosting = useSelector(getSuperAdminUserIsPosting);
    const postSuccess = useSelector(getSuperAdminUserPostSuccess);

    return {
        handleSubmit,
        formState,
        handleChange,
        postSuccess,
        isPosting,
    };
}

interface FormState {
    password: string;
    confirmPassword: string;
}

interface UpdateSuperAdminPasswordReturn {
    handleSubmit: () => void;
    formState: FormState;
    handleChange: <T>(name: 'password' | 'confirmPassword', value: T) => void;
    postSuccess: boolean;
    isPosting: boolean;
}
